<template>
  <div>
    <p v-for="(line, index) in lines" :key="index" class="card-line">
      {{ line.text }}
    </p>
    <h4 class="card-line-item">Tom de voz</h4>
    <div class="card-line-with-icon">
      <h4>Próximo e familiar</h4>
      <component :is="icons[0]" />
    </div>
    <div class="card-line-with-icon">
      <h4>Marcante e<br>inconfundível</h4>
      <component :is="icons[1]" />
    </div>
    <div class="card-line-with-icon">
      <h4>Adaptável e<br>detalhista</h4>
      <component :is="icons[2]" />
    </div>
    <div class="card-line-with-icon">
      <h4>Transparente e<br>contundente</h4>
      <component :is="icons[3]" />
    </div>    
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class CardContent extends Vue {
  @Prop() lines!: { text: string }[]
  @Prop() icons!: (typeof Vue)[]
}
</script>

<style scoped>
.card-line {
  font-size: 16px;        
}

.card-line:first-child {
  margin-top: 5px;
}

.card-line-item {
  margin-top: 40px;
  font-weight: 700;   
}

.card-line-with-icon {  
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 700;     
}
</style>